var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHideIconMobile = function SvgHideIconMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "hide-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.737,
    height: 10.363
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108467",
    d: "M9.848 5.181a1.481 1.481 0 1 1-1.481-1.48 1.48 1.48 0 0 1 1.481 1.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108468",
    d: "M16.339 4.706C16.178 4.514 12.347 0 8.369 0S.56 4.514.399 4.706l-.4.476.4.476c.161.192 3.992 4.706 7.97 4.706s7.809-4.514 7.97-4.706l.4-.476Zm-7.97 3.437a2.961 2.961 0 1 1 2.961-2.961 2.964 2.964 0 0 1-2.961 2.96Z"
  })));
};
export default SvgHideIconMobile;